// Imports
import React from "react";
import tick from "src/files/tick.svg";

const RecSummary = ({ title, subtitle }) => {
  return (
    <>
      <div className="rec-summary">
        <div className="rec-summary__icon-wrapper">
          <img className="rec-summary__icon-tick" src={tick} alt="" />
        </div>
        {title && <h2 className="rec-summary__title">{title}</h2>}
        {subtitle && <p className="rec-summary__subtitle">{subtitle}</p>}
      </div>
    </>
  );
};

export default RecSummary;
